import request from './http';

////获取首页设计单位列表
export function lists(data = {}) {
  const params = {
    prov_id: data.prov_id || null,
    mold_id: data.mold_id || null,
    mold_ids: data.mold_ids || null,
    search: data.search || null,
    is_index: data.is_index || 2, //是否首页展示 1是 2否 不是首页展示时获取全部列表	 
    page: data.page || 1,
    page_size: data.page_size || 8,
  };
  return request.post('html/Index/getDesignStoreList', params);
}

//获取设计单位的推荐商家
export function getRecommendStoreList(data = {}) {
  return request.post('html/user/getRecommendStoreList', data);
}
//推荐商家  添加反馈
export function addProposal(data = {}) {
  return request.post('html/user/addProposal', data);
}
